import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LanguageService } from '@app/services/language/language.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';

export const lang_selected$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {
  public languageCode = 'en-ca';
  constructor(
    public _languageService: LanguageService,
    public _translateService: TranslateService,
    public _cookieService: CookieService
    ) { }

    @Output() onLanguageChangeEvent = new EventEmitter<string>();
    public cookie: CookieService;
    
  ngOnInit() {
      const cookie = this._cookieService.get('trakr-counting-lang');
      if(cookie){ 
        lang_selected$.next(cookie);
        this.languageCode = cookie;
        this._translateService.use(cookie);
      }
  }

  changeLang(res:string):void{
    this.languageCode = res;
    this._cookieService.set('trakr-counting-lang', res);
    lang_selected$.next(res);
    this._translateService.use(res);
  }

}
